import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const ConfirmDialog = ({ open, title, content, onClose, onConfirm, disableBackdropClose }) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        // Only block backdrop clicks when disableBackdropClose is true
        if (disableBackdropClose && reason === "backdropClick") {
          return;
        }
        onClose(event, reason);
      }}
      disableEscapeKeyDown={disableBackdropClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">
        {title || "Confirm Action"}
        <IconButton
          onClick={(event) => onClose(event, 'closeButtonClick')}
          style={{ position: 'absolute', right: 10, top: 12 }}
          aria-label="close"
          title="Close"
        >
          <GridCloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {content || "Are you sure you want to proceed?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(event) => onClose(event, 'cancelButtonClick')} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disableBackdropClose: PropTypes.bool
};

export default ConfirmDialog;
